import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

import beach from '../assets/Shutters_Beach.json';
import desert from '../assets/Shutters_Desert.json';
import forest from '../assets/Shutters_Forest.json';
import rollingHills from '../assets/Shutters_RollingHills.json';
import skier from '../assets/Shutters_Skier.json';
import vineyard from '../assets/Shutters_Vinyard.json';

const scenes = [beach, skier, rollingHills, desert, forest, vineyard];

const ShutterSequence = () => {
  const layerARef = useRef(null);
  const layerBRef = useRef(null);
  const animationRefs = useRef([null, null]);

  useEffect(() => {
    let cancelled = false;

    const getLayerEl = (slot) => (slot === 0 ? layerARef.current : layerBRef.current);

    const destroySlot = (slot) => {
      const anim = animationRefs.current[slot];
      if (anim) {
        anim.destroy();
        animationRefs.current[slot] = null;
      }
    };

    const mountScene = (slot, sceneIndex) => {
      const el = getLayerEl(slot);

      destroySlot(slot);
      el.innerHTML = '';

      const anim = lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: scenes[sceneIndex],
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          clearCanvas: true,
        },
      });

      if (!anim) return null;

      animationRefs.current[slot] = anim;

      anim.addEventListener('complete', () => {
        if (cancelled) return;

        const nextSlot = slot === 0 ? 1 : 0;
        const nextSceneIndex = (sceneIndex + 1) % scenes.length;
        const currentEl = getLayerEl(slot);
        const nextEl = getLayerEl(nextSlot);

        if (!currentEl || !nextEl) return;

        // Make sure the next layer starts hidden
        nextEl.style.opacity = '0';

        const nextAnim = mountScene(nextSlot, nextSceneIndex);
        if (!nextAnim) return;

        // Wait until the next animation's SVG is ready before swapping
        nextAnim.addEventListener(
          'DOMLoaded',
          () => {
            if (cancelled) return;

            requestAnimationFrame(() => {
              currentEl.style.opacity = '0';
              nextEl.style.opacity = '1';
              destroySlot(slot);
            });
          },
          { once: true }
        );
      });

      return anim;
    };

    if (layerARef.current) layerARef.current.style.opacity = '1';
    if (layerBRef.current) layerBRef.current.style.opacity = '0';

    mountScene(0, 0);

    return () => {
      cancelled = true;
      destroySlot(0);
      destroySlot(1);
    };
  }, []);

  return (
    <div style={{
      position: 'relative', width: 140, height: 200, overflow: 'hidden',
    }}
    >
      <div
        ref={layerARef}
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 1,
        }}
      />
      <div
        ref={layerBRef}
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0,
        }}
      />
    </div>
  );
};

export default ShutterSequence;
